import { Box, Typography } from "@mui/material"
import type { FC } from "react"

export type DetailField = [label: string, value: string | number | undefined | null | JSX.Element]

interface DetailFieldListProps {
  fields: DetailField[]
  "data-testid"?: string
}

export const DetailFieldList: FC<DetailFieldListProps> = ({ fields, "data-testid": testId }) => {
  return (
    <Box className='flex flex-col gap-2 rounded bg-white p-4' data-testid={testId}>
      {fields.map(([label, value]) => (
        <Box key={label} className='flex items-center gap-4'>
          <Box className='w-[250px] shrink-0'>
            <Typography variant='caption' color='text.secondary'>
              {label}
            </Typography>
          </Box>
          <Box className='flex-1'>
            <Typography variant='body2' fontWeight={500} component='div'>
              {value ?? "-"}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}
